import { useState } from "react";
import useImage from "../../../../hooks/imageHook";
import FileUpload from "../../../../components/elements/FileUpload/FileUpload";
import Button from "../../../../components/form-control/Button";
import { showToast } from "../../../../utils/miscFunctions";


interface IFleetUploadModal {
    onProceed: () => void;
    onClose: () => void;
    disbursementId: number;
}

const UploadDisbursementEvidence = ({ onProceed, onClose, disbursementId }: IFleetUploadModal) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [evidenceFile, setEvidenceFile] = useState<File | null>(null);
    const { getImageFormData, uploadImage } = useImage();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            if (evidenceFile) {
                setLoading(true);
                const response: any = await uploadImage(evidenceFile, `admin/disbursements/${disbursementId}/upload-evidence`, 'post');
                if (response) {
                    showToast.success(response.message ?? 'Payment advice uploaded successfully');
                    onProceed();
                }
            }
        } catch (error: any) {
            showToast.error(error.description ?? 'Failed to upload payment advice');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="p-5 rounded-xl">
            <form onSubmit={handleSubmit}>
                <FileUpload
                    label="Upload payment advice"
                    onFileLoad={(images: any) => {
                        if (images && images[0]) {
                            setEvidenceFile(images[0]);
                        }
                    }}
                    showFileMax={false}
                    onFileDeleted={() => {
                        setEvidenceFile(null);
                    }}
                    defaultImage={''}
                    cropImage={false}
                    maxHeight={90}
                    maxWidth={200}
                    imageContainerHeight={'200px'}
                    imageAlt={'Payment advice'}
                />

                <div className="w-full flex gap-4 mt-5">
                    <Button
                        type="button"
                        label="Cancel"
                        bgColor='secondary'
                  fullWidth
                        disabled={loading}
                        loading={loading}
                        onClick={onClose}
                    />
                    <Button
                        type="submit"
                        label="Upload"
                        bgColor='primary'
              fullWidth
                        disabled={loading}
                        loading={loading}
                    />
                </div>
            </form>
        </div>
    );
};

export default UploadDisbursementEvidence;